import { useMemo } from 'react';
import { WixPrivatemediaProxyServer } from '@wix/ambassador-wix-privatemedia-proxy-server/http';

import { useMMGRSettings } from '../hoc/withMMGRSettings';

const baseUrl = '/_api/wix-privatemedia-proxy-server';
const getPrivateMediaServer = () => WixPrivatemediaProxyServer(baseUrl);

export const usePrivateMediaProxyMediaManagerService = () => {
  const {
    mmgrSettings: { metaSiteToken },
  } = useMMGRSettings();
  return useMemo(
    () => getPrivateMediaServer().MediaManagerService()({ Authorization: metaSiteToken }),
    [metaSiteToken],
  );
};

export const usePrivateMediaProxySearchService = () => {
  const {
    mmgrSettings: { metaSiteToken },
  } = useMMGRSettings();
  return useMemo(() => getPrivateMediaServer().SearchService()({ Authorization: metaSiteToken }), [metaSiteToken]);
};
